'use strict';

angular.module('app.services')

.service('Chat', chatService)

chatService.$inject = ['$resource', 'ConfigApp']

function chatService($resource, ConfigApp)
{   
    return {
        mensagens : function(){
            return $resource(ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/chat_atendimento/mensagens?sistemaOrigemId=' + ConfigApp.CentralAppId,
                { chamadoId: '@chamadoId' }, {
                    get: {
                        method: 'GET',
                        isArray: true
                    }
            });
        },
        resposta: function( params ){
            return $resource(
                ConfigApp.UrlApi + '/v1.0/chamados/:chamadoId/chat_atendimento/mensagens?origemParticipante=:origemParticipante', 
                { chamadoId: '@chamadoId', origemParticipante: '@origemParticipante' }, {
                    enviar: {
                        method: 'POST',
                        headers: { 'Content-Type': undefined, enctype: 'multipart/form-data' },
                        params: params
                    }
            });
        }
    }

}


// WEBPACK FOOTER //
// ./src/services/chat-service.js